<template>
  <footer class="container-fluid grid grid-cols-2 gap-6 py-10">
    <div class="col-span-1 px-3 flex justify-end">
      <a href="https://martrec.uark.edu" target="_blank">
        <img :src="martrecLogoSrc" alt="MarTREC: Maritime Transporation Research & Education Center" />
      </a>
    </div>
    <div class="col-span-1 px-3 flex justify-start">
      <a href="https://cast.uark.edu" target="_blank">
        <img :src="castLogoSrc" alt="CAST Logo" />
      </a>
    </div>
    <div class="col-span-2 px-3 flex text-center justify-center text-blue-700">
      <span class="container-fluid grid grid-rows-2">
        <a href="https://form.asana.com/?k=MJjiEv_At0u8C4hMPhlo1A&d=964360232897899" target="_blank">
          Having issues? <span><b>Contact us.</b></span>
        </a>
        <span class="flex flex-col text-xs text-gray-600">
          <p>
            <span class="text-gray-900 font-medium">Note:</span>
            TransMAP works best in Chrome or Firefox.
          </p>
          <p>Safari has known issues.</p>
        </span>
      </span>
    </div>
  </footer>
</template>

<script>
import martrec from '@/assets/logos/martrec.png'
import cast from '@/assets/logos/cast.png'

export default {
  name: 'default-footer',
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      martrecLogoSrc: martrec,
      castLogoSrc: cast,
    }
  },
}
</script>

<style scoped>

img {
  max-height: 75px;
  height: auto;
  width: auto;
}

</style>
